module.exports = __webpack_public_path__ + "static/fonts/Montserrat600.bbcd5bbb.ttf";